import { Button, Modal, Stack, Text, TextInput } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import React from 'react';

import { ModalFooter } from '@portals/core';

import { CreateCustomerFormValues } from './create-customer.types';
import { CustomerLogoWrapper } from './CustomerLogoWrapper';

interface EditCustomerProps {
  closeMe: () => void;
  onUploadLogo: () => void;
  form: UseFormReturnType<CreateCustomerFormValues>;
  onSubmit: (values: CreateCustomerFormValues) => void;
  isLoading: boolean;
}
export function EditCustomer({
  form,
  onSubmit,
  onUploadLogo,
  closeMe,
  isLoading,
}: EditCustomerProps) {
  return (
    <Modal opened onClose={closeMe} title="Edit customer" padding="xxl">
      <form onSubmit={form.onSubmit(onSubmit)}>
        <Stack spacing="xxl">
          <CustomerLogoWrapper form={form} onUploadLogo={onUploadLogo} />

          <Stack spacing="xl">
            <Text
              c="gray.6"
              fz="lg"
              ta="center"
              data-testid="what-is-customer-name-title"
            >
              What is the customer’s name?
            </Text>

            <TextInput
              required
              data-autofocus
              placeholder="Customer's name"
              {...form.getInputProps('customerName')}
              data-testid="customer-name-input"
            />
          </Stack>
        </Stack>

        <ModalFooter position="right" pt="xxl">
          <Button variant="default" onClick={closeMe}>
            Cancel
          </Button>

          <Button
            type="submit"
            disabled={!form.values.customerName.trim()}
            data-testid="create-customer-button"
            loading={isLoading}
          >
            Save changes
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  );
}
